var _excluded = ["treeData", "defaultCheckedKeys", "checkedKeys", "selectedKeys", "defaultSelectedKeys", "defaultExpandedKeys", "className", "style", "header", "customFooter", "onCheck", "onExpand", "onSelect", "onNodeClick"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import { cx } from '@emotion/css';
import { SearchTreeContext } from "../SearchTree/SearchTree";
import { disabledClass, dividingLine, prefix, tooltipClass, treeContentClass, treeStyle } from "./index.style";
import { createTreeModel } from "./TreeModel";
import TreeNode, { TreeNodeContext } from "./TreeNode";
import useThemeProps from "../../hooks/useThemeProps";
import { useOnUpdate } from "../../hooks/useOnUpdate";
import { regular_12, regular_14, regular_16, styleScrollbar } from "../../styles";
import { useFreshStaticValue } from "../../hooks/useFreshStaticValue";
export var TreeContext = /*#__PURE__*/React.createContext(null);
TreeContext.displayName = 'TreeContext';
export { TreeNodeContext };

var formatProps = function formatProps(_ref) {
  var size = _ref.size,
      defaultExpandAll = _ref.defaultExpandAll,
      disabled = _ref.disabled,
      lazy = _ref.lazy,
      showLine = _ref.showLine,
      checkable = _ref.checkable,
      strict = _ref.strict,
      noStyle = _ref.noStyle,
      showIcon = _ref.showIcon,
      multiple = _ref.multiple,
      expandAnimation = _ref.expandAnimation,
      useEllipsis = _ref.useEllipsis;
  return {
    size: size,
    lazy: Boolean(lazy),
    strict: Boolean(strict),
    defaultExpandAll: Boolean(defaultExpandAll),
    checkable: Boolean(checkable),
    disabled: Boolean(disabled),
    showLine: Boolean(showLine),
    showIcon: Boolean(showIcon),
    noStyle: Boolean(noStyle),
    expandAnimation: Boolean(expandAnimation),
    multiple: Boolean(multiple),
    useEllipsis: Boolean(useEllipsis)
  };
};

var Tree = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _header7, _header8, _header9;

  var treeData = _ref2.treeData,
      defaultCheckedKeys = _ref2.defaultCheckedKeys,
      checkedKeys = _ref2.checkedKeys,
      selectedKeys = _ref2.selectedKeys,
      defaultSelectedKeys = _ref2.defaultSelectedKeys,
      defaultExpandedKeys = _ref2.defaultExpandedKeys,
      customClass = _ref2.className,
      style = _ref2.style,
      header = _ref2.header,
      customFooter = _ref2.customFooter,
      onCheck = _ref2.onCheck,
      onExpand = _ref2.onExpand,
      onSelect = _ref2.onSelect,
      onNodeClick = _ref2.onNodeClick,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  var theme = useThemeProps();

  var _formatProps = formatProps(restProps),
      size = _formatProps.size,
      checkable = _formatProps.checkable,
      defaultExpandAll = _formatProps.defaultExpandAll,
      disabled = _formatProps.disabled,
      lazy = _formatProps.lazy,
      noStyle = _formatProps.noStyle,
      showIcon = _formatProps.showIcon,
      showLine = _formatProps.showLine,
      strict = _formatProps.strict,
      expandAnimation = _formatProps.expandAnimation,
      useEllipsis = _formatProps.useEllipsis;
  /* format */


  var INNER_MODE = false;

  if (checkable) {
    if (!Array.isArray(checkedKeys)) {
      checkedKeys = undefined;
      INNER_MODE = true;
    }
  } else {
    if (!Array.isArray(selectedKeys)) {
      selectedKeys = undefined;
      INNER_MODE = true;
    }

    header = undefined;
  }

  var treeModel = React.useMemo(function () {
    var _header;

    var _checkedKeys = checkedKeys || defaultCheckedKeys;

    var _selectedKeys = selectedKeys || defaultSelectedKeys;

    return createTreeModel({
      strict: strict,
      treeData: Array.isArray(treeData) ? treeData : [],
      selectedKeys: Array.isArray(_selectedKeys) ? _selectedKeys : [],
      checkedKeys: Array.isArray(_checkedKeys) ? _checkedKeys : [],
      expandedKeys: Array.isArray(defaultExpandedKeys) ? defaultExpandedKeys : [],
      defaultExpandAll: defaultExpandAll,
      lazy: lazy,
      header: (_header = header) !== null && _header !== void 0 ? _header : {
        title: 'Select All'
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var _React$useState = React.useState(treeModel.getRoot().treeNode.children),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      treeList = _React$useState2[0],
      setTreeList = _React$useState2[1];

  var el = React.useRef(null);
  var contentEl = React.useRef(null);

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      tooltipContent = _React$useState4[0],
      setTooltipContent = _React$useState4[1];

  var layout = React.useMemo(function () {
    switch (size) {
      case 'large':
        return {
          size: size,
          indent: 24,
          space: 8,
          iconSize: 16,
          height: 30,
          lineHeight: 20,
          fontStyle: regular_16
        };

      default:
      case 'medium':
        return {
          size: size,
          indent: 24,
          space: 8,
          iconSize: 16,
          height: 26,
          lineHeight: 16,
          fontStyle: regular_14
        };

      case 'small':
        return {
          size: size,
          indent: 18,
          space: 6,
          iconSize: 12,
          height: 22,
          lineHeight: 14,
          fontStyle: regular_12
        };
    }
  }, [size]);
  var staticConfig = useFreshStaticValue({
    lazy: lazy,
    strict: strict,
    isHoverTooltip: false,
    el: el,
    contentEl: contentEl,
    header: header,
    defaultExpandAll: defaultExpandAll,
    noStyle: noStyle,
    expandAnimation: expandAnimation,
    onCheck: onCheck,
    onExpand: onExpand,
    onSelect: onSelect,
    onNodeClick: onNodeClick,
    tooltip: function tooltip(rcNode, style) {
      if (provide.staticConfig.isHoverTooltip) {
        return;
      }

      var timer;
      setTooltipContent(rcNode ? /*#__PURE__*/React.createElement("div", {
        onMouseEnter: function onMouseEnter(e) {
          e.stopPropagation();
          clearTimeout(timer);
          provide.staticConfig.isHoverTooltip = true;
        },
        onMouseLeave: function onMouseLeave(e) {
          e.stopPropagation();
          provide.staticConfig.isHoverTooltip = false;
          clearTimeout(timer);
          timer = setTimeout(function () {
            setTooltipContent(null);
          }, 400);
        },
        className: tooltipClass(),
        style: style
      }, rcNode) : null);
    }
  }, {
    needToUpdate: {
      onCheck: onCheck,
      onExpand: onExpand,
      onSelect: onSelect,
      onNodeClick: onNodeClick,
      header: header,
      defaultExpandAll: defaultExpandAll,
      noStyle: noStyle,
      expandAnimation: expandAnimation
    }
  });
  var provide = React.useMemo(function () {
    return {
      timer: undefined,
      treeModel: treeModel,
      checkable: checkable,
      showLine: showLine,
      disabled: disabled,
      useEllipsis: useEllipsis,
      INNER_MODE: INNER_MODE,
      layoutConfig: layout,
      staticConfig: staticConfig.current,
      showIcon: showIcon
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layout, checkable, INNER_MODE, disabled, showLine, showIcon, useEllipsis]);
  /* searchTree mix */

  {
    var searchTreeContext = useContext(SearchTreeContext);

    if (searchTreeContext !== null && searchTreeContext !== void 0 && searchTreeContext.registerTreeContext) {
      searchTreeContext.registerTreeContext({
        treeModel: treeModel,
        layout: layout
      });
    }
  }
  React.useImperativeHandle(ref, function () {
    return {
      el: el,
      contentEl: contentEl,
      getCheckedKeys: function getCheckedKeys() {
        return Promise.resolve().then(function () {
          var _provide$treeModel = provide.treeModel,
              getModel = _provide$treeModel.getModel,
              getRoot = _provide$treeModel.getRoot,
              getSelectedKeys = _provide$treeModel.getSelectedKeys,
              computeFilteredKeys = _provide$treeModel.computeFilteredKeys,
              strict = provide.staticConfig.strict;
          var root = getRoot();
          var result = getSelectedKeys(root, strict);
          var filteredKeys = strict ? [] : computeFilteredKeys(root, function (_ref3) {
            var key = _ref3.key;
            return getModel(key);
          });
          return _objectSpread(_objectSpread({}, result), {}, {
            filteredKeys: filteredKeys
          });
        }).catch(function () {
          return {
            selectedKeys: [],
            particalSelectedKeys: [],
            filteredKeys: []
          };
        });
      },
      getSelectedKeys: function getSelectedKeys() {
        return Promise.resolve().then(function () {
          var selected = provide.treeModel.selected;
          return {
            selectedKeys: selected ? [selected] : []
          };
        });
      }
    };
  });
  useOnUpdate(function () {
    var root = treeModel.getRoot();

    var rawRootNode = _objectSpread(_objectSpread({}, root.treeNode), {}, {
      children: Array.isArray(treeData) ? treeData : []
    });

    treeModel.closeContext();
    treeModel.models = {};
    treeModel.openContext(treeModel.models);

    var _checkedKeys = checkedKeys || defaultCheckedKeys || [];

    treeModel.initialize(treeModel.id, rawRootNode, _toConsumableArray(_checkedKeys), _toConsumableArray(treeModel.expandedKeys), -1, {
      lazy: lazy,
      defaultExpandAll: defaultExpandAll,
      strict: strict
    });

    treeModel._run(function () {
      treeModel._rawData = [rawRootNode];
    });

    {
      var model = treeModel.getRoot();

      model.getExpanded = function () {
        return false;
      };

      model.getChecked = function () {
        var root = treeModel.getRoot();
        var checked = treeModel.computeCheckedWithChildren(root.snapshot);
        return checked === 'all';
      };
    }
    setTreeList(treeModel.getRoot().treeNode.children);
  }, [treeData]);
  useOnUpdate(function () {
    var root = treeModel.getRoot();

    if (header) {
      var _header$title, _header2, _header3, _header$color, _header4, _header$iconColor, _header5, _header6;

      Object.assign(root.treeNode, {
        title: (_header$title = (_header2 = header) === null || _header2 === void 0 ? void 0 : _header2.title) !== null && _header$title !== void 0 ? _header$title : root.treeNode.title,
        icon: (_header3 = header) === null || _header3 === void 0 ? void 0 : _header3.icon,
        color: (_header$color = (_header4 = header) === null || _header4 === void 0 ? void 0 : _header4.color) !== null && _header$color !== void 0 ? _header$color : root.treeNode.color,
        iconColor: (_header$iconColor = (_header5 = header) === null || _header5 === void 0 ? void 0 : _header5.iconColor) !== null && _header$iconColor !== void 0 ? _header$iconColor : root.treeNode.iconColor,
        useEllipsis: (_header6 = header) === null || _header6 === void 0 ? void 0 : _header6.useEllipsis
      });
      root.trigger({
        type: 'refresh'
      });
    }
  }, [(_header7 = header) === null || _header7 === void 0 ? void 0 : _header7.color, (_header8 = header) === null || _header8 === void 0 ? void 0 : _header8.icon, (_header9 = header) === null || _header9 === void 0 ? void 0 : _header9.title]);
  useOnUpdate(function () {
    var _checkedKeys = checkedKeys;

    if (!checkedKeys) {
      _checkedKeys = [];
    }

    if (!provide.INNER_MODE && _checkedKeys && !provide.disabled) {
      treeModel.target = undefined;
      var isStrictMode = staticConfig.current.strict; // remove

      var _iterator = _createForOfIteratorHelper(treeModel.selectedKeys),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;

          if (!treeModel.getModel(key)) {
            continue;
          }

          if (!_checkedKeys.includes(key)) {
            if (!isStrictMode) {
              treeModel.chooseNodeAllChildren(key, 'none');
              treeModel.chooseNodeAndComputeParentNode(key, 'none');
            } else {
              treeModel.chooseNodeStrict(key, 'none');
            }
          }
        } // add

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(_checkedKeys),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _key = _step2.value;

          if (!treeModel.getModel(_key)) {
            continue;
          }

          if (!strict) {
            treeModel.chooseNodeAllChildren(_key, 'all');
            treeModel.chooseNodeAndComputeParentNode(_key, 'all');
          } else {
            treeModel.chooseNodeStrict(_key, 'all');
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      treeModel._run();
    }
  }, [INNER_MODE, checkedKeys]);
  useOnUpdate(function () {
    if (provide.INNER_MODE || !selectedKeys || provide.disabled) return;
    var key = String(selectedKeys);
    var model = treeModel.getModel(key);

    if (model) {
      model.trigger({
        type: 'select',
        currentItem: model.treeNode,
        value: true
      });
    } else {
      treeModel.trigger({
        type: 'select',
        currentItem: null,
        value: true
      });
    }
  }, [selectedKeys]);
  var themeStyle = React.useMemo(function () {
    return treeStyle(layout, theme, noStyle);
  }, [layout, theme, noStyle]);
  var scrollBarStyle = React.useMemo(function () {
    return styleScrollbar(theme);
  }, [theme]);
  var treeListContent = React.useMemo(function () {
    return treeList.map(function (child) {
      return /*#__PURE__*/React.createElement(TreeNode, {
        key: child.key,
        level: 0,
        treeNode: child,
        nodeKey: child.key,
        isUseExpand: true
      });
    });
  }, [treeList]);
  return /*#__PURE__*/React.createElement("div", {
    ref: el,
    className: cx(themeStyle, prefix(), _defineProperty({}, disabledClass(), disabled), customClass),
    style: Object.assign({
      maxWidth: '480px',
      maxHeight: '480px'
    }, style)
  }, /*#__PURE__*/React.createElement(TreeContext.Provider, {
    value: provide
  }, header && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TreeNode, {
    isUseExpand: false,
    key: "#__root__#",
    nodeKey: "#__root__#",
    level: -1,
    treeNode: treeModel.getRoot().treeNode
  }), /*#__PURE__*/React.createElement("div", {
    className: dividingLine()
  })), /*#__PURE__*/React.createElement("div", {
    ref: contentEl,
    className: cx(treeContentClass(), scrollBarStyle)
  }, treeListContent), customFooter && customFooter({
    deliver: /*#__PURE__*/React.createElement("div", {
      className: dividingLine()
    })
  }), tooltipContent));
});
Tree.defaultProps = {
  size: 'medium',
  defaultExpandAll: false,
  checkable: false,
  strict: false,
  disabled: false,
  showLine: false,
  showIcon: false,
  multiple: false,
  lazy: false,
  noStyle: false,
  expandAnimation: true,
  useEllipsis: true
};
Tree.displayName = 'Tree';
export default /*#__PURE__*/React.memo(Tree);